export default __webpack_public_path__ + "static/media/Social_icon.dbe2e895.svg";